import React from 'react'

export default () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M13.5 2H11V5.33333H13.5V2Z" fill="currentColor"/>
    <path d="M13.5 7H11V22H13.5V7Z" fill="currentColor"/>
  </svg>

)
